import { render, staticRenderFns } from "./AddonTikTokPixel.vue?vue&type=template&id=65e0d15e&scoped=true&"
import script from "./AddonTikTokPixel.vue?vue&type=script&lang=js&"
export * from "./AddonTikTokPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0d15e",
  null
  
)

export default component.exports